// eslint-disable-next-line no-use-before-define
import ThemeProvider from '@mui/system/ThemeProvider';
import { SnackbarProvider } from 'notistack';
// eslint-disable-next-line no-use-before-define
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import './i18n/config';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import theme from './utils/theme';
import { AuthProvider } from './utils/context/Auth.context';
import { UserCompanyProvider } from './utils/context/UserCompany.context';
import { ModeProvider } from './utils/context/Mode.context';
import LoadingIndicator from './components/loading-indicator/LoadingIndicator';

const queryClient = new QueryClient();

declare global {
  interface Window {
    showSponaApp?: () => void;
  }
}

const revealApp = () => {
  if (typeof window.showSponaApp === 'function') {
    window.showSponaApp();
    return;
  }

  document.body.classList.remove('app-is-loading');
  const preloader = document.getElementById('app-preloader');
  if (preloader) {
    preloader.remove();
  }
};

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={5}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <UserCompanyProvider>
                <ModeProvider>
                  <Suspense
                    fallback={
                      <LoadingIndicator
                        sxCp={{ color: 'primaryLight.500' }}
                        sx={{ marginTop: '25%' }}
                      />
                    }
                  >
                    <App />
                  </Suspense>
                </ModeProvider>
              </UserCompanyProvider>
            </AuthProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
  () => {
    window.requestAnimationFrame(revealApp);
  },
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
